// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-art-js": () => import("./../src/pages/art.js" /* webpackChunkName: "component---src-pages-art-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-projects-js": () => import("./../src/pages/projects.js" /* webpackChunkName: "component---src-pages-projects-js" */),
  "component---src-pages-qoins-jsx": () => import("./../src/pages/qoins.jsx" /* webpackChunkName: "component---src-pages-qoins-jsx" */),
  "component---src-pages-recycle-atl-jsx": () => import("./../src/pages/recycleATL.jsx" /* webpackChunkName: "component---src-pages-recycle-atl-jsx" */),
  "component---src-pages-yay-stack-jsx": () => import("./../src/pages/YayStack.jsx" /* webpackChunkName: "component---src-pages-yay-stack-jsx" */)
}

